import React from 'react'
import ManageBranch from '../pages/ManageBranches'
import OnboardNewBranch from '../pages/ManageBranches/OnboardNewBranch'
import InstitutionProfile from '../pages/Profile/InstitutionProfile'
import ViewBranches from '../pages/ManageBranches/ViewBranches'
import ManageStaff from '../pages/ManageStaff'
import AddUser from '../components/ViewOnboardingBranch/AddUser'
import UpdateProfilePassword from '../pages/Profile/UpdatePassword'
import OnlinePayments from '../pages/Settings/PaymentGateway'
import ViewStaff from '../components/ManageStaff/ViewStaff'
import EmptyScreen from '../components/EmptyScreen'
import OnboardSection from '../pages/MainHub/Sections/OnboardSection'
import ManageClasses from '../pages/MainHub/Classes'
import ReorderClasses from '../pages/MainHub/Classes/Reorder'
import AddClass from '../components/ManageClasses/AddClass'
import AddSubject from '../components/ManageSubject/AddSubject'
import ManageGroupsLedgers from '../pages/MainHub/GroupsLedgers'
import AddEditGroupsLegers from '../pages/MainHub/GroupsLedgers/components/AddEditGroupsLegers'
import ManageInstitutionUserList from '../pages/ManageInstitutionUsers'
import AddNewInstitutionUser from '../pages/ManageInstitutionUsers/AddNewInstitutionUser'
import AddNewAcademicYear from '../pages/Years/ManageAcademicYears/AddAcademicYear'
import ManageAcademicYearList from '../pages/Years/ManageAcademicYears/index'
import FeeTerm from '../pages/FeeManagement/FeeTerm'
import AddFeeTerm from '../pages/FeeManagement/FeeTerm/components/AddFeeTerm'
import AddFeeStructure from '../pages/FeeManagement/FeeStructure/components/AddFeeStructure'
import MangeFeeStructure from '../pages/FeeManagement/FeeStructure'
import ManageAssociation from '../pages/ManageAssociation'
import AddAssociation from '../pages/ManageAssociation/componnets/AddAssociation'
import AddStudent from '../pages/StudentMaster/Directory/AddStudent'
import ManageStudentsDirectoryList from '../pages/StudentMaster/Directory'
import ViewStudent from '../pages/StudentMaster/Directory/ViewStudent'
import AcademicRecords from '../pages/StudentMaster/AcademicRecords'
import Attendance from '../pages/StudentMaster/Attendance'
import ViewIndividualAttendance from '../pages/StudentMaster/Attendance/Components/ViewIndividualAttendance'
import ModifyStudentAttendance from '../pages/StudentMaster/Attendance/ModifyAttendance/ModifyStudentAttendance'
import FinancialYear from '../pages/Years/ManageFinancialYear'
import InventoryList from '../pages/InventoryMaster/InventoryList'
import AddInventoryList from '../pages/InventoryMaster/InventoryList/Components/AddInventoryMaster'
import AddPurchaseOrder from '../pages/InventoryMaster/PurchaseOrder/Components/AddPurchaseOrder'
import PurchaseOrder from '../pages/InventoryMaster/PurchaseOrder'
import AddGRNEntry from '../pages/InventoryMaster/GRNEntry'
import ViewGrn from '../pages/InventoryMaster/PurchaseOrder/Components/ViewGrn'
import Payroll from '../pages/EmployeeMaster/Payroll'
import Payslips from '../pages/Profile/Payslips'
import IssueInventory from '../pages/InventoryMaster/InventoryList/Components/IssueInventory'
import InvoiceList from '../pages/StudentMaster/InvoicesList'
import InvoiceDetails from '../pages/StudentMaster/InvoicesList/InvoicesDetails'
import CollectFee from '../pages/StudentMaster/CollectFee'
import CollectFeeInvoice from '../pages/StudentMaster/CollectFee/Componets/CollectFeeInvoice'
import PromoteStudent from '../pages/StudentMaster/PromoteStudent'
import PromoteHistory from '../pages/StudentMaster/PromoteStudent/PromoteHistory'
import TransferStudent from '../pages/StudentMaster/TransferStudent'
import AddTransferStudent from '../pages/StudentMaster/TransferStudent/OutwardList/AddTransferStudent'
import ProcessTransfer from '../pages/StudentMaster/TransferStudent/InwardList/ProcessTransfer'
import FeeCollection from '../pages/StudentMaster/FeeCollection'
import FeeCollectionDetails from '../pages/StudentMaster/FeeCollection/FeeCollectionDetails'
import InventoryIssueReport from '../pages/InventoryMaster/InventoryIssueReport'
import VouchersEntryList from '../pages/Accounting/VouchersEntry'
import VoucherContra from '../pages/Accounting/VouchersEntry/Components/VoucherContra'
import VoucherReceipt from '../pages/Accounting/VouchersEntry/Components/VoucherReceipt'
import VoucherRTEScholarship from '../pages/Accounting/VouchersEntry/Components/VoucherRTEScholarship'
import VoucherJournal from '../pages/Accounting/VouchersEntry/Components/VoucherJournal'
import ViewPurchaseOrder from '../pages/InventoryMaster/PurchaseOrder/ViewPO'
import GRNList from '../pages/InventoryMaster/GRNEntry/GRNList'
import VoucherPayment from '../pages/Accounting/VouchersEntry/Components/VoucherPayment'
import ViewGRNDetails from '../pages/InventoryMaster/GRNEntry/ViewGRN'
import Payables from '../pages/Accounting/Payables'
import InventoryStockReport from '../pages/InventoryMaster/InventoryStockReport'
import BalanceSheet from '../pages/FinancialStatements/BalanceSheet'
import ProfitAndLoss from '../pages/FinancialStatements/ProfitAndLoss'
import TrialBalance from '../pages/FinancialStatements/TrialBalance'
import ReceiptsAndPayments from '../pages/FinancialStatements/ReceiptsAndPayments'
import AccessDenied from '../components/AccesDenied'
import VoucherDetails from '../pages/Accounting/VouchersEntry/VouchersDetails'
import PromotionDetails from '../pages/StudentMaster/PromoteStudent/PromoteHistory/PromotionDetails'
import LedgerDetails from '../pages/MainHub/GroupsLedgers/LedgerDetails';
import BulkInvoiceHistory from '../pages/StudentMaster/InvoicesList/BulkInvoiceHistory';
import InvoiceIssueStatus from '../pages/StudentMaster/InvoicesList/InvoiceIssueStatus';
import UpdateFeeStructure from '../pages/StudentMaster/Directory/UpdateFeeStructure'
import StudentList from '../pages/StudentMaster/Directory/UpdateFeeStructure/StudentList'
import ManageHolidayCalendar from '../pages/HolidayCalendar';
import ClassDiary from '../pages/NoticeBoard/Classroom'
import AddHomework from '../pages/NoticeBoard/Classroom/Homework/AddHomework'
import ViewHomework from '../pages/NoticeBoard/Classroom/Homework/ViewHomework'
import AddUpdate from '../pages/NoticeBoard/Classroom/Updates/AddUpdate'
import ViewUpdate from '../pages/NoticeBoard/Classroom/Updates/ViewUpdate'
import Broadcasts from '../pages/NoticeBoard/Broadcasts'
import AddBroadcast from '../pages/NoticeBoard/Broadcasts/AddBroadcast'
import ViewBroadcast from '../pages/NoticeBoard/Broadcasts/ViewBroadcast'


export const  ComponentsBasedOnRole ={
    "institution-user":
    [
        {
            name  : 'Profile',
            element: <InstitutionProfile Type="Institution"/>,
            path : '/',
            roleKey : 'profile'
        },
        {
            name  : 'Access Denied',
            element: <AccessDenied/>,
            path : '/access-denied',
            roleKey : 'accessDenied'
        },
        {
            name :  "Profile",
            element : <ViewStaff userType={"institution-user"} ApiType={"cognito"}/>,
            path : '/profile/my-profile',
            roleKey: "profile"
        },
        {
            name  : 'Profile',
            element: <UpdateProfilePassword Type="Institution"/>,
            path : '/profile/update-password',
            roleKey : 'profile'
        },
        {
            name  : 'Payment Gateway',
            element: <OnlinePayments />,
            path : '/settings/payment-gateway',
            roleKey : 'settings'
        },
        {
            name  : 'Branches',
            element:<ViewBranches />,
            path : '/manage-branches/:id',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<AddUser userType={"branch-user"} actionType={"Add"} />,
            path : '/manage-branches/:id/add-branch-user',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<AddUser userType={"branch-user"} actionType={"Add"} edit/>,
            path : '/manage-branches/:id/edit-branch-user/:email_address',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<ManageBranch />,
            path : '/manage-branches',
            roleKey: 'branches'
        },
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch />,
            path : '/manage-branches/onboard-new-branch',
            roleKey: 'branches'      
        },
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch edit/>,
            path : '/manage-branches/onboard-new-branch/edit/:id',
            roleKey: 'branches'      
        },
    
        {
            name  : 'Profile',
            element:<InstitutionProfile Type="Institution"/>,
            path : '/profile/institution-profile',
            roleKey : 'profile'

        },
        {
            name :  "Holiday Management",
            element : <ManageHolidayCalendar type={'branchHoliday'}/>,
            path : '/holiday-management',
            roleKey: "holiday-management"
        },
        {
            name :  "Employee Directory",
            element : <ManageStaff />,
            path : '/employee-master/manage-employee',
            roleKey: "employee-directory"
        },
        {
            name :  "Employee Directory",
            element : <AddUser userType={"staff-user"} actionType={"Add"} />,
            path : '/employee-master/manage-employee/add-employee',
            roleKey: "employee-directory"
        },
        {
            name :  "Employee Directory",
            element : <AddUser userType={"staff-user"} actionType={"Edit"} edit/>,
            path : '/employee-master/manage-employee/edit-staff/:email_address',
            roleKey: "employee-directory"

        },
        {
            name :  "Employee Directory",
            element : <ViewStaff userType={"staff-user"} ApiType={'API'}/>,
            path : '/employee-master/manage-employee/view-employee/:id',
            roleKey: "employee-directory"
        },
        {
            name :  "Main Hub",
            element : <ManageClasses type="sections"/>,
            path : '/main-hub/manage-sections',
            roleKey: "sections"
        },
        {
            name :  "Onboard Section",
            element : <AddClass Type={"Add"} type="sections"/>,
            path : '/main-hub/manage-sections/add-section',
            roleKey: "sections"
        },
        {
            name :  "Onboard Section",
            element : <OnboardSection userType={"staff-user"} actionType={"Edit"}/>,
            path : '/main-hub/manage-sections/edit-section/:id',
            roleKey: "sections"
        },
        {
            name : "Main Hub",
            element : <ReorderClasses type="sections" />,
            path : '/main-hub/manage-sections/reorder',
            roleKey: "sections"
        },
        
        { 
            name :  "Classes",
            element : <ManageClasses type="classes"/>,
            path : '/main-hub/classes',
            roleKey: "classes"
        },
        {
            
            name :  "Classes",
            element : <AddClass Type={"Add"} type={'classes'}/>,
            path : '/main-hub/classes/add-class',
            roleKey: "classes"
        },
        {
            
            name :  "Classes",
            element : <AddClass Type={"Edit"}/>,
            path : '/main-hub/classes/edit-class/:id',
            roleKey: "classes"
        },
        {
            name : "Classes",
            element : <ReorderClasses />,
            path : '/main-hub/classes/reorder',
            roleKey: "classes"
        },
        {
            
            name :  "subjects",
            element : <ManageClasses type="subjects"/>,
            path : '/main-hub/subjects',
            roleKey: "subjects"
        },
        {
            name :  "subjects",
            element : <AddClass actionType={"Add"} type={'subjects'}/>,
            path : '/main-hub/subjects/add-subjects',
            roleKey: "subjects"
        },
        {
            name :  "subjects",
            element : <AddSubject actionType={"Edit"}/>,
            path : '/main-hub/subjects/edit-subjects/:id',
            roleKey: "subjects"
        },
        {
            
            name :  "Fee Heads",
            element : <ManageClasses type="fee head"/>,
            path : "/fee-management/fee-head",
            roleKey: "fee-heads"
        },
        {
            
            name :  "Fee Heads",
            element : <AddClass type="fee head"/>,
            path : "/fee-management/fee-head/add-fee-head",
            roleKey: "fee-heads"
        },
        {
            
            name  : 'Fee Structures',
            element : <AddFeeStructure Type={"Add"}/>,
            path : "/fee-management/fee-structure/add-fee-structure",
            roleKey: "fee-structures"
        },
        {
            
            name  : 'Fee Structures',
            element : <MangeFeeStructure />,
            path : "/fee-management/fee-structure",
            roleKey: "fee-structures"
        },
        {
            name:"Fee Structure",
            element:<AddFeeStructure Type={"Edit"}/>,
            path:"/fee-management/fee-structure/update-fee-structure/:fee_structure_id",
            roleKey:"fee-structures"
        },
        {
            name:"Fee Structure",
            element:<AddFeeStructure Type={"View"}/>,
            path:"/fee-management/fee-structure/view-fee-structure/:fee_structure_id",
            roleKey:"fee-structures"
        },
        { 
            name  : 'Ledgers/Groups',
            element : <ManageGroupsLedgers />,
            path : '/main-hub/groups-ledgers',
            roleKey:"ledgers/groups"
        },
        
        {
            
            name  : 'Ledgers/Groups',
            element : <AddEditGroupsLegers Type={"Add"}/>,
            path : '/main-hub/groups-ledgers/add-groups-ledgers',
            roleKey:"ledgers/groups"
        },
        {
            
            name  : 'Ledgers/Groups',
            element : <AddEditGroupsLegers Type={"Edit"}/>,
            path : '/main-hub/groups-ledgers/edit-groups-ledgers/:id',
            roleKey:"ledgers/groups"
        },
        {
            name: 'Ledger Details',
            element: <LedgerDetails />,
            path: '/main-hub/groups-ledgers/ledger-details/:id',
            roleKey: "ledgers/groups"
        },
        {
            
            name  : 'InstitutionUsers',
            element : <ManageInstitutionUserList/>,
            path : '/manage-institution-users',
            roleKey:"institution-users"
        },
        {
            name  : 'InstitutionUsers',
            element : <AddNewInstitutionUser/>,
            path : '/manage-institution-users/add-new-user',
            roleKey:"institution-users"
        },
        {
            name  : 'InstitutionUsers',
            element : <AddNewInstitutionUser edit/>,
            path : '/manage-institution-users/edit/:email_address',
            roleKey:"institution-users"
        },
        {
            name  : 'Exams',
            element : <ManageClasses type="exam"/>,
            path : "/student-master/exam",
            roleKey: 'exams'
        },
        { 
            name  : 'Exams',
            element : <AddClass type="exam"/>,
            path : "/student-master/exam/add-exam",
            roleKey: 'exams'
        },
        {
            
            name :  "Directory",
            element : <ManageStudentsDirectoryList />,
            path : "/student-master/directory",
            roleKey: "directory"
        },
        {
            
            name :  "Directory",
            element : <AddStudent />,
            path : "/student-master/directory/add-student",
            roleKey: "directory"
        },
        {
            
            name :  "Directory",
            element : <AddStudent edit/>,
            path : "/student-master/directory/edit-student/:id",
            roleKey: "directory"
        },
        {
            name  : 'Directory',
            element:<ViewStudent />,
            path : '/student-master/directory/:id',
            roleKey: 'directory'
        },
        {
            name  : 'Directory',
            element:<UpdateFeeStructure />,
            path : '/student-master/directory/update-fee-structure',
            roleKey: 'directory'
        },
        {
            name  : 'Directory',
            element:<StudentList />,
            path : '/student-master/directory/update-fee-structure/student-list',
            roleKey: 'directory'
            
        },
        
        {
            name :  "Collect Fee",
            element : <CollectFee />,
            path : "/student-master/collect-fee",
            roleKey: "collect-fee"
        },
        {
            name :  "Collect Fee",
            element : <CollectFeeInvoice />,
            path : "/student-master/collect-fee/collect-fee-invoice/:id",
            roleKey: "collect-fee"
        },
        {
            name:"Term",
            element:<FeeTerm />,
            path:'/fee-management/fee-terms',
            roleKey:'fee-terms'
        },
        {
            name:"Term",
            element:<AddFeeTerm />,
            path:'/fee-management/fee-terms/create-fee-term',
            roleKey:'fee-terms'
        },
        {
            name:"Term",
            element:<AddFeeTerm edit/>,
            path:'/fee-management/fee-terms/view-fee-term/:id',
            roleKey:'fee-terms'
        },
        {
            
            name  : 'AcademicYear',
            element : <ManageAcademicYearList/>,
            path : '/manage-academic-years',
            roleKey : 'profile'
        },
        {
            name  : 'AcademicYear',
            element : <AddNewAcademicYear/>,
            path : '/manage-academic-years/add-new-academic-year',
            roleKey : 'profile'
        },
        {
            name  : 'AcademicYear',
            element : <AddNewAcademicYear edit/>,
            path : '/manage-academic-years/edit/:academic_year_id',
            roleKey : 'profile'
        },
        {
            name  : 'Class Association',
            element : <ManageAssociation/>,
            path : '/employee-master/manage-association',
            roleKey:"class-association"
        },
        {
            name  : 'Class Association',
            element : <AddAssociation/>,
            path : '/employee-master/manage-association/add-association',
            roleKey:"class-association"
        },
        {
            name  : 'Class Association',
            element : <AddAssociation edit/>,
            path : '/employee-master/manage-association/add-association/:id',
            roleKey:"class-association"
        },
        {
            name  : 'Academic Reports',
            element : <AcademicRecords />,
            path : '/student-master/class-wise-academic-reports',
            roleKey:"academic-reports"
        },
        {
            name  : 'Student Attendance',
            element : <Attendance />,
            path : '/student-master/student-attendance',
            roleKey:"students-attendance"
        },
        {
            name  : 'View Attendance',
            element : <ViewIndividualAttendance />,
            path : '/student-master/student-attendance/view-attendance/:id/:name',
            roleKey:"students-attendance"
        },
        {
            name:'Student Attendance',
            element:<ModifyStudentAttendance/>,
            path:'/student-master/student-attendance/modify-attendance',
            roleKey:"students-attendance"
        },
        {
            name  : 'Financial Year',
            element:<FinancialYear/>,
            path:'/manage-financial-years',
            roleKey : 'profile'
        },
        // staff attendance

        {
            name  : 'Employee Attendance',
            element : <Attendance type={"staff"}/>,
            path : '/employee-master/employee-attendance',
            roleKey:"employees-attendance"
        },
        {
            name  : 'Staff View Attendance',
            element : <ViewIndividualAttendance type={"staff"}/>,
            path : '/employee-master/employee-attendance/view-attendance/:number/:name/:id',
            roleKey:"employees-attendance"
        },
        {
            name:'staff Attendance',
            element:<ModifyStudentAttendance type={"staff"}/>,
            path:'/employee-master/employee-attendance/modify-attendance',
            roleKey:"employees-attendance"
        },

        // Inventory List
        {
            name  : 'Inventory',
            element : <InventoryList />,
            path : '/inventory-master/inventory-list',
            roleKey:"inventory"
        },
        {
            name  : 'Inventory List Add',
            element : <AddInventoryList type={"Add"}/>,
            path : '/inventory-master/inventory-list/add-inventory',
            roleKey:"inventory"
        },
        {
            name:'Inventory List Edit',
            element:<AddInventoryList type={"Edit"}/>,
            path:'/inventory-master/inventory-list/edit-inventory/:id',
            roleKey:"inventory"
        },
        {
            name:'View GRN',
            element:<ViewGrn />,
            path:'/inventory-master/inventory-list/view-grn',
            roleKey:"inventory"
        },
        {
            name:'Issue-Inventory',
            element:<IssueInventory type={"inventory-master"}/>,
            path:'/inventory-master/inventory-list/issue-inventory',
            roleKey:"inventory"
        },
        
        // Purchase Order
        {
            name  : 'Purchase Order',
            element : <PurchaseOrder />,
            path : '/inventory-master/purchase-order',
            roleKey:"purchase-order"
        },
        {
            name  : 'Purchase Order Add',
            element : <AddPurchaseOrder type={"Add"}/>,
            path : '/inventory-master/purchase-order/add-purchase-order',
            roleKey:"purchase-order"
        },
        {
            name:'Purchase Order Edit',
            element:<AddPurchaseOrder type={"Edit"}/>,
            path:'/inventory-master/purchase-order/edit-purchase-order/:id',
            roleKey:"purchase-order"
        },
        {
            name:'Purchase Order View',
            element:<ViewPurchaseOrder />,
            path:'/inventory-master/purchase-order/view-purchase-order/:id',
            roleKey:"purchase-order"
        },

        // GRN Entry
        {
            name  : 'GRN Entry Add',
            element : <AddGRNEntry type={"Add"}/>,
            path : '/inventory-master/grn-entry/add-grn-entry',
            roleKey:"grn-entry"
        },
        {
            name  : 'GRN Entry List',
            element : <GRNList/>,
            path : '/inventory-master/grn-entry',
            roleKey:"grn-entry"
        },
        {
            name  : 'GRN Entry View',
            element : <ViewGRNDetails/>,
            path : '/inventory-master/grn-entry/view-grn-entry/:id',
            roleKey:"grn-entry"
        },

        // Payroll
        
        {
            name :  "Payroll",
            element : <Payroll />,
            path : '/employee-master/payroll',
            roleKey: "payroll"

        },

        // Invoices
        {
            name :  "Invoices",
            element : <InvoiceList />,
            path : '/student-master/invoice-list',
            roleKey: "invoices"
        },
        {
            name:'Invoice Details',
            element:<InvoiceDetails />,
            path:'/student-master/invoice-list/invoices-details/:id',
            roleKey:"invoices"
        },
        {
            name:'Issue-Inventory',
            element:<IssueInventory type={"student-master"}/>,
            path:'/student-master/invoice-list/issue-inventory',
            roleKey:"invoices"
        },

        //Promote Student
        {
            name :  "Promote Students",
            element : <PromoteStudent/>,
            path : '/student-master/promote-history/promote-students',
            roleKey: "promote-students"
        },
        {
            name :  "Promote History",
            element : <PromoteHistory/>,
            path : '/student-master/promote-history',
            roleKey: "promote-students"
        },
        {
            name :  "Promotion Details",
            element : <PromotionDetails/>,
            path : '/student-master/promote-history/promotion-details/:id',
            roleKey: "promote-students"
        },
        { 
            name: "transfer-students",
            element: <EmptyScreen tittle={'404'} />,
            path: '/transfer-students',
            roleKey: "transfers"
        },
        { 
            name: "Fee Collection Report",
            element: <FeeCollection />,
            path: '/student-master/fee-collection',
            roleKey: "fee-collection-report"
        },
        { 
            name: "Fee Collection Details",
            element: <FeeCollectionDetails />,
            path: '/student-master/fee-collection/fee-collection-details/:id',
            roleKey: "fee-collection-report"
        },
        { 
            name: "inventory-stock-report",
            element: <InventoryStockReport />,
            path: '/inventory-master/inventory-stock-report',
            roleKey: "inventory-stock-report"
        },
        { 
            name: "inventory-issue-report",
            element: <InventoryIssueReport/>, 
            path: '/inventory-master/inventory-issue-report',
            roleKey: "inventory-issue-report"
        },
        { 
            name: "payables",
            element: <Payables/>,
            path: '/accounting/payables',
            roleKey: "payables"
        },
        { 
            name: "balance-sheet",
            element: <BalanceSheet type={'main'}/>,
            path: '/financial-statements/balance-sheet',
            roleKey: "balance-sheet"
        },
        { 
            name: "profit-and-loss-sheet",
            element: <ProfitAndLoss type={'main'} />,
            path: '/financial-statements/profit-and-loss-sheet',
            roleKey: "profit-and-loss-sheet"
        },
        { 
            name: "trial-balance-sheet",
            element: <TrialBalance type={'main'} />,
            path: '/financial-statements/trial-balance-sheet',
            roleKey: "trial-balance-sheet"
        },
        { 
            name: "receipts-and-payments",
            element: <ReceiptsAndPayments type={'main'} />,
            path: '/financial-statements/receipts-and-payments',
            roleKey: "receipts-and-payments"
        },

        // Transfer Student
        {
            name :  "Transfers",
            element : <TransferStudent />,
            path : "/student-master/transfers",
            roleKey: "transfers"
        },
        {
            name :  "Transfers",
            element : <AddTransferStudent />,
            path : "/student-master/transfers/add-transfer-student",
            roleKey: "transfers"
        },
        // Process Transfer
        {
            name :  "Transfers",
            element : <ProcessTransfer />,
            path : "/student-master/transfers/process-transfer/:transfer_id",
            roleKey: "transfers"
        },
        // Voucher Entry
        {
            name: "vouchers-entry",
            element: <VouchersEntryList />,
            path: "/accounting/voucher-entry",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-contra",
            element: <VoucherContra />,
            path: "/accounting/voucher-entry/voucher-type-contra",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-receipt",
            element: <VoucherReceipt />,
            path: "/accounting/voucher-entry/voucher-type-receipt",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-RTES_cholarship",
            element: <VoucherRTEScholarship />,
            path: "/accounting/voucher-entry/voucher-type-RTE-Scholarship",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-journal",
            element: <VoucherJournal />,
            path: "/accounting/voucher-entry/voucher-type-journal",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-payment",
            element: <VoucherPayment />,
            path: "/accounting/voucher-entry/voucher-type-payment",
            roleKey: "vouchers-entry"
        },
        {
            name: "voucher-details",
            element: <VoucherDetails />,
            path: "/accounting/voucher-entry/voucher-details/:id",
            roleKey: "vouchers-entry"
        },
        {
            name: 'Bulk Invoice Issue History',
            element: <BulkInvoiceHistory />,
            path: '/student-master/invoice-list/bulk-invoice-history',
            roleKey: 'invoices'
        },
        {
            name: 'Invoice Issue Status',
            element: <InvoiceIssueStatus />,
            path: '/student-master/invoice-list/bulk-invoice-history/invoice-issue-status',
            roleKey: 'invoices'
        },
        {
            name: 'Classroom',
            element: <ClassDiary />,
            path: '/noticeboard/classroom',
            roleKey: 'classroom'
        },
        {
            name: 'Add Homework',
            element: <AddHomework />,
            path: '/noticeboard/classroom/homework/add',
            roleKey: 'classroom'
        },
        {
            name: 'Edit Homework',
            element: <AddHomework edit />,
            path: '/noticeboard/classroom/homework/edit/:id',
            roleKey: 'classroom'
        },
        {
            name: 'View Homework',
            element: <ViewHomework />,
            path: '/noticeboard/classroom/homework/view/:id',
            roleKey: 'classroom'
        },
        {
            name: 'Add Update',
            element: <AddUpdate />,
            path: '/noticeboard/classroom/updates/add',
            roleKey: 'classroom'
        },
        {
            name: 'Edit Update',
            element: <AddUpdate edit />,
            path: '/noticeboard/classroom/updates/edit/:id',
            roleKey: 'classroom'
        },
        {
            name: 'View Update',
            element: <ViewUpdate />,
            path: '/noticeboard/classroom/updates/view/:id',
            roleKey: 'classroom'
        },
        {
            name: 'Broadcasts',
            element: <Broadcasts />,
            path: '/noticeboard/broadcasts',
            roleKey: 'broadcasts'
        },
        {
            name: 'Add Broadcast',
            element: <AddBroadcast />,
            path: '/noticeboard/broadcasts/add',
            roleKey: 'broadcasts'
        },
        {
            name: 'Edit Broadcast',
            element: <AddBroadcast edit />,
            path: '/noticeboard/broadcasts/edit/:id',
            roleKey: 'broadcasts'
        },
        {
            name: 'View Broadcast',
            element: <ViewBroadcast />,
            path: '/noticeboard/broadcasts/view/:id',
            roleKey: 'broadcasts'
        },
    ],
    "institution-admin":
    [
        {
            name  : 'Profile',
            element: <InstitutionProfile Type="Institution"/>,
            path : '/',
            roleKey : 'profile'
        },
        {
            name  : 'Access Denied',
            element: <AccessDenied/>,
            path : '/access-denied',
            roleKey : 'accessDenied'
        },
        {
            name :  "Profile",
            element : <ViewStaff userType={"institution-admin"} ApiType={"cognito"}/>,
            path : '/profile/my-profile',
            roleKey: "profile"
        },
        {
            name  : 'Profile',
            element: <UpdateProfilePassword Type="Institution"/>,
            path : '/profile/update-password',
            roleKey : 'profile'
        },
        {
            name  : 'Payment Gateway',
            element: <OnlinePayments />,
            path : '/settings/payment-gateway',
            roleKey : 'settings'
        },
        {
            name  : 'Branches',
            element:<ViewBranches />,
            path : '/manage-branches/:id',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<AddUser userType={"branch-user"} actionType={"Add"} />,
            path : '/manage-branches/:id/add-branch-user',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<AddUser userType={"branch-user"} actionType={"Add"} edit/>,
            path : '/manage-branches/:id/edit-branch-user/:email_address',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<ManageBranch />,
            path : '/manage-branches',
            roleKey: 'branches'
        },
    
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch />,
            path : '/manage-branches/onboard-new-branch',
            roleKey: 'branches'      
        },
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch edit/>,
            path : '/manage-branches/onboard-new-branch/edit/:id',
            roleKey: 'branches'      
        },
    
        {
            name  : 'Profile',
            element:<InstitutionProfile Type="Institution"/>,
            path : '/profile/institution-profile',
            roleKey : 'profile'

        },
        {
            name :  "Holiday Management",
            element : <ManageHolidayCalendar type={'branchHoliday'}/>,
            path : '/holiday-management',
            roleKey: "holiday-management"
        },
        {
            name :  "Employee Directory",
            element : <ManageStaff />,
            path : '/employee-master/manage-employee',
            roleKey: "employee-directory"

        },
        {
            name :  "Employee Directory",
            element : <AddUser userType={"staff-user"} actionType={"Add"} />,
            path : '/employee-master/manage-employee/add-employee',
            roleKey: "employee-directory"

        },
        {
            name :  "Employee Directory",
            element : <AddUser userType={"staff-user"} actionType={"Edit"} edit/>,
            path : '/employee-master/manage-employee/edit-staff/:email_address',
            roleKey: "employee-directory"

        },
        {
            name :  "Employee Directory",
            element : <ViewStaff userType={"staff-user"} ApiType={'API'}/>,
            path : '/employee-master/manage-employee/view-employee/:id',
            roleKey: "employee-directory"
        },
        {
            name :  "Main Hub",
            element : <ManageClasses type="sections"/>,
            path : '/main-hub/manage-sections',
            roleKey: "sections"
        },
        {
            name :  "Onboard Section",
            element : <AddClass Type={"Add"} type="sections"/>,
            path : '/main-hub/manage-sections/add-section',
            roleKey: "sections"
        },
        {
            name :  "Onboard Section",
            element : <OnboardSection userType={"staff-user"} actionType={"Edit"}/>,
            path : '/main-hub/manage-sections/edit-section/:id',
            roleKey: "sections"
        },
        {
            name : "Main Hub",
            element : <ReorderClasses type="sections" />,
            path : '/main-hub/manage-sections/reorder',
            roleKey: "sections"
        },
        
        { 
            name :  "Classes",
            element : <ManageClasses type="classes"/>,
            path : '/main-hub/classes',
            roleKey: "classes"
        },
        {
            
            name :  "Classes",
            element : <AddClass Type={"Add"} type={'classes'}/>,
            path : '/main-hub/classes/add-class',
            roleKey: "classes"
        },
        {
            
            name :  "Classes",
            element : <AddClass Type={"Edit"}/>,
            path : '/main-hub/classes/edit-class/:id',
            roleKey: "classes"
        },
        {
            name : "Classes",
            element : <ReorderClasses />,
            path : '/main-hub/classes/reorder',
            roleKey: "classes"
        },
        {
            
            name :  "subjects",
            element : <ManageClasses type="subjects"/>,
            path : '/main-hub/subjects',
            roleKey: "subjects"
        },
        {
            name :  "subjects",
            element : <AddClass actionType={"Add"} type={'subjects'}/>,
            path : '/main-hub/subjects/add-subjects',
            roleKey: "subjects"
        },
        {
            name :  "subjects",
            element : <AddSubject actionType={"Edit"}/>,
            path : '/main-hub/subjects/edit-subjects/:id',
            roleKey: "subjects"
        },
        {
            
            name :  "Fee Heads",
            element : <ManageClasses type="fee head"/>,
            path : "/fee-management/fee-head",
            roleKey: "fee-heads"
        },
        {
            
            name :  "Fee Heads",
            element : <AddClass type="fee head"/>,
            path : "/fee-management/fee-head/add-fee-head",
            roleKey: "fee-heads"
        },
        {
            
            name  : 'Fee Structures',
            element : <AddFeeStructure Type={"Add"}/>,
            path : "/fee-management/fee-structure/add-fee-structure",
            roleKey: "fee-structures"
        },
        {
            
            name  : 'Fee Structures',
            element : <MangeFeeStructure />,
            path : "/fee-management/fee-structure",
            roleKey: "fee-structures"
        },  
        {
            name:"Fee Structure",
            element:<AddFeeStructure Type={"Edit"}/>,
            path:"/fee-management/fee-structure/update-fee-structure/:fee_structure_id",
            roleKey:"fee-structures"
        },
        {
            name:"Fee Structure",
            element:<AddFeeStructure Type={"View"}/>,
            path:"/fee-management/fee-structure/view-fee-structure/:fee_structure_id",
            roleKey:"fee-structures"
        },
        { 
            name  : 'Ledgers/Groups',
            element : <ManageGroupsLedgers />,
            path : '/main-hub/groups-ledgers',
            roleKey:"ledgers/groups"
        },
        
        {
            
            name  : 'Ledgers/Groups',
            element : <AddEditGroupsLegers Type={"Add"}/>,
            path : '/main-hub/groups-ledgers/add-groups-ledgers',
            roleKey:"ledgers/groups"
        },
        {
            
            name  : 'Ledgers/Groups',
            element : <AddEditGroupsLegers Type={"Edit"}/>,
            path : '/main-hub/groups-ledgers/edit-groups-ledgers/:id',
            roleKey:"ledgers/groups"
        },
        {
            name: 'Ledger Details',
            element: <LedgerDetails />,
            path: '/main-hub/groups-ledgers/ledger-details/:id',
            roleKey: "groups-ledgers"
        },
        {
            
            name  : 'InstitutionUsers',
            element : <ManageInstitutionUserList/>,
            path : '/manage-institution-users',
            roleKey:"institution-users"
        },
        ,{
            
            name  : 'InstitutionUsers',
            element : <AddNewInstitutionUser/>,
            path : '/manage-institution-users/add-new-user',
            roleKey:"institution-users"
        },
        {
            
            name  : 'InstitutionUsers',
            element : <AddNewInstitutionUser edit/>,
            path : '/manage-institution-users/edit/:email_address',
            roleKey:"institution-users"
        },
        {
            
            name  : 'AcademicYear',
            element : <ManageAcademicYearList/>,
            path : '/manage-academic-years',
            roleKey : 'profile'
        },
        ,{
            
            name  : 'AcademicYear',
            element : <AddNewAcademicYear/>,
            path : '/manage-academic-years/add-new-academic-year',
            roleKey : 'profile'
        },
        {
            
            name  : 'AcademicYear',
            element : <AddNewAcademicYear edit/>,
            path : '/manage-academic-years/edit/:academic_year_id',
            roleKey : 'profile'
        },
        {
            
            name  : 'Exams',
            element : <ManageClasses type="exam"/>,
            path : "/student-master/exam",
            roleKey: 'exams'
        },
        {
            
            name  : 'Exams',
            element : <AddClass type="exam"/>,
            path : "/student-master/exam/add-exam",
            roleKey: 'exams'
        },
        {
            
            name :  "Directory",
            element : <ManageStudentsDirectoryList />,
            path : "/student-master/directory",
            roleKey: "directory"
        },
        {
            
            name :  "Directory",
            element : <AddStudent />,
            path : "/student-master/directory/add-student",
            roleKey: "directory"
        },
        {
            
            name :  "Directory",
            element : <AddStudent edit/>,
            path : "/student-master/directory/edit-student/:id",
            roleKey: "directory"
        },
        {
            name  : 'Directory',
            element:<ViewStudent />,
            path : '/student-master/directory/:id',
            roleKey: 'directory'
        },
        {
            name  : 'Directory',
            element:<UpdateFeeStructure />,
            path : '/student-master/directory/update-fee-structure',
            roleKey: 'directory'
        },
        {
            name  : 'Directory',
            element:<StudentList />,
            path : '/student-master/directory/update-fee-structure/student-list',
            roleKey: 'directory'
            
        },
        {
            
            name :  "Collect Fee",
            element : <CollectFee />,
            path : "/student-master/collect-fee",
            roleKey: "collect-fee"
        },
        {
            name :  "Collect Fee",
            element : <CollectFeeInvoice />,
            path : "/student-master/collect-fee/collect-fee-invoice/:id",
            roleKey: "collect-fee"
        },
        {
            name:"Term",
            element:<FeeTerm />,
            path:'/fee-management/fee-terms',
            roleKey:'fee-terms'
        },
        {
            name:"Term",
            element:<AddFeeTerm />,
            path:'/fee-management/fee-terms/create-fee-term',
            roleKey:'fee-terms'
        },
        {
            name:"Term",
            element:<AddFeeTerm edit/>,
            path:'/fee-management/fee-terms/view-fee-term/:id',
            roleKey:'fee-terms'
        },
        {
            
            name  : 'Class Association',
            element : <ManageAssociation/>,
            path : '/employee-master/manage-association',
            roleKey:"class-association"
        },
        {
            
            name  : 'Class Association',
            element : <AddAssociation/>,
            path : '/employee-master/manage-association/add-association',
            roleKey:"class-association"
        },
        {
                    
            
            name  : 'Class Association',
            element : <AddAssociation edit/>,
            path : '/employee-master/manage-association/add-association/:id',
            roleKey:"class-association"
        },
        {
            name  : 'Academic Reports',
            element : <AcademicRecords />,
            path : '/student-master/class-wise-academic-reports',
            roleKey:"academic-reports"
        },
        {
            name  : 'Student Attendance',
            element : <Attendance />,
            path : '/student-master/student-attendance',
            roleKey:"students-attendance"
        },
        {
            name  : 'View Attendance',
            element : <ViewIndividualAttendance />,
            path : '/student-master/student-attendance/view-attendance/:id/:name',
            roleKey:"students-attendance"
        },
        {
            name:'Student Attendance',
            element:<ModifyStudentAttendance/>,
            path:'/student-master/student-attendance/modify-attendance',
            roleKey:"students-attendance"
        },
        {
            name  : 'Financial Year',
            element:<FinancialYear/>,
            path:'/manage-financial-years',
            roleKey : 'profile'
        },
        // staff attendance

        {
            name  : 'Employee Attendance',
            element : <Attendance type={"staff"}/>,
            path : '/employee-master/employee-attendance',
            roleKey:"employees-attendance"
        },
        {
            name  : 'Staff View Attendance',
            element : <ViewIndividualAttendance type={"staff"}/>,
            path : '/employee-master/employee-attendance/view-attendance/:number/:name/:id',
            roleKey:"employees-attendance"
        },
        {
            name:'staff Attendance',
            element:<ModifyStudentAttendance type={"staff"}/>,
            path:'/employee-master/employee-attendance/modify-attendance',
            roleKey:"employees-attendance"
        },

        // Inventory List
        {
            name  : 'Inventory',
            element : <InventoryList />,
            path : '/inventory-master/inventory-list',
            roleKey:"inventory"
        },
        {
            name  : 'Inventory List Add',
            element : <AddInventoryList type={"Add"}/>,
            path : '/inventory-master/inventory-list/add-inventory',
            roleKey:"inventory"
        },
        {
            name:'Inventory List Edit',
            element:<AddInventoryList type={"Edit"}/>,
            path:'/inventory-master/inventory-list/edit-inventory/:id',
            roleKey:"inventory"
        },
        {
            name:'View GRN',
            element:<ViewGrn />,
            path:'/inventory-master/inventory-list/view-grn',
            roleKey:"inventory"
        },
        {
            name:'Issue-Inventory',
            element:<IssueInventory type={"inventory-master"}/>,
            path:'/inventory-master/inventory-list/issue-inventory',
            roleKey:"inventory"
        },
        // Purchase Order
        {
            name  : 'Purchase Order',
            element : <PurchaseOrder />,
            path : '/inventory-master/purchase-order',
            roleKey:"purchase-order"
        },
        {
            name  : 'Purchase Order Add',
            element : <AddPurchaseOrder type={"Add"}/>,
            path : '/inventory-master/purchase-order/add-purchase-order',
            roleKey:"purchase-order"
        },
        {
            name:'Purchase Order Edit',
            element:<AddPurchaseOrder type={"Edit"}/>,
            path:'/inventory-master/purchase-order/edit-purchase-order/:id',
            roleKey:"purchase-order"
        },
        {
            name:'Purchase Order View',
            element:<ViewPurchaseOrder />,
            path:'/inventory-master/purchase-order/view-purchase-order/:id',
            roleKey:"purchase-order"
        },

        // GRN Entry
        {
            name  : 'GRN Entry Add',
            element : <AddGRNEntry type={"Add"}/>,
            path : '/inventory-master/grn-entry/add-grn-entry',
            roleKey:"grn-entry"
        },
        {
            name  : 'GRN Entry List',
            element : <GRNList/>,
            path : '/inventory-master/grn-entry',
            roleKey:"grn-entry"
        },
        {
            name  : 'GRN Entry View',
            element : <ViewGRNDetails/>,
            path : '/inventory-master/grn-entry/view-grn-entry/:id',
            roleKey:"grn-entry"
        },
        // Payroll
        
        {
            name :  "Payroll",
            element : <Payroll />,
            path : '/employee-master/payroll',
            roleKey: "payroll"

        },
        // Invoices
        {
            name :  "Invoices",
            element : <InvoiceList />,
            path : '/student-master/invoice-list',
            roleKey: "invoices"
        },
        {
            name:'Invoice Details',
            element:<InvoiceDetails />,
            path:'/student-master/invoice-list/invoices-details/:id',
            roleKey:"invoices"
        },
        {
            name:'Issue-Inventory',
            element:<IssueInventory type={"student-master"}/>,
            path:'/student-master/invoice-list/issue-inventory',
            roleKey:"invoices"
        },
        //Promote Student
        {
            name :  "Promote Students",
            element : <PromoteStudent/>,
            path : '/student-master/promote-history/promote-students',
            roleKey: "promote-students"
        },
        {
            name :  "Promote History",
            element : <PromoteHistory/>,
            path : '/student-master/promote-history',
            roleKey: "promote-students"
        },
        {
            name :  "Promotion Details",
            element : <PromotionDetails/>,
            path : '/student-master/promote-history/promotion-details/:id',
            roleKey: "promote-students"
        },
        { 
            name: "Fee Collection Report",
            element: <FeeCollection />,
            path: '/student-master/fee-collection',
            roleKey: "fee-collection-report"
        },
        { 
            name: "Fee Collection Details",
            element: <FeeCollectionDetails />,
            path: '/student-master/fee-collection/fee-collection-details/:id',
            roleKey: "fee-collection-report"
        },
        { 
            name: "inventory-stock-report",
            element: <InventoryStockReport />,
            path: '/inventory-master/inventory-stock-report',
            roleKey: "inventory-stock-report"
        },
        { 
            name: "inventory-issue-report",
            element: <InventoryIssueReport/>, 
            path: '/inventory-master/inventory-issue-report',
            roleKey: "inventory-issue-report"
        },
        { 
            name: "payables",
            element: <Payables/>,
            path: '/accounting/payables',
            roleKey: "payables"
        },
        { 
            name: "balance-sheet",
            element: <BalanceSheet type={'main'}/>,
            path: '/financial-statements/balance-sheet',
            roleKey: "balance-sheet"
        },

        { 
            name: "profit-and-loss-sheet",
            element: <ProfitAndLoss type={'main'} />,
            path: '/financial-statements/profit-and-loss-sheet',
            roleKey: "profit-and-loss-sheet"
        },
        { 
            name: "trial-balance-sheet",
            element: <TrialBalance type={'main'} />,
            path: '/financial-statements/trial-balance-sheet',
            roleKey: "trial-balance-sheet"
        },
        { 
            name: "receipts-and-payments",
            element: <ReceiptsAndPayments type={'main'} />,
            path: '/financial-statements/receipts-and-payments',
            roleKey: "receipts-and-payments"
        },

        // Transfer Student
        {
            name :  "Transfers",
            element : <TransferStudent />,
            path : "/student-master/transfers",
            roleKey: "transfers"
        },
        {
            name :  "Transfers",
            element : <AddTransferStudent />,
            path : "/student-master/transfers/add-transfer-student",
            roleKey: "transfers"
        },
        // Process Transfer
        {
            name :  "Transfers",
            element : <ProcessTransfer />,
            path : "/student-master/transfers/process-transfer/:transfer_id",
            roleKey: "transfers"
        },
        // Voucher Entry
        {
            name: "vouchers-entry",
            element: <VouchersEntryList />,
            path: "/accounting/voucher-entry",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-contra",
            element: <VoucherContra />,
            path: "/accounting/voucher-entry/voucher-type-contra",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-receipt",
            element: <VoucherReceipt />,
            path: "/accounting/voucher-entry/voucher-type-receipt",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-RTES_cholarship",
            element: <VoucherRTEScholarship />,
            path: "/accounting/voucher-entry/voucher-type-RTE-Scholarship",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-journal",
            element: <VoucherJournal />,
            path: "/accounting/voucher-entry/voucher-type-journal",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-payment",
            element: <VoucherPayment />,
            path: "/accounting/voucher-entry/voucher-type-payment",
            roleKey: "vouchers-entry"
        },
        {
            name: "voucher-details",
            element: <VoucherDetails />,
            path: "/accounting/voucher-entry/voucher-details/:id",
            roleKey: "vouchers-entry"
        },
        {
            name: 'Bulk Invoice Issue History',
            element: <BulkInvoiceHistory />,
            path: '/student-master/invoice-list/bulk-invoice-history',
            roleKey: 'invoices'
        },
        {
            name: 'Invoice Issue Status',
            element: <InvoiceIssueStatus />,
            path: '/student-master/invoice-list/bulk-invoice-history/invoice-issue-status',
            roleKey: 'invoices'
        },
        {
            name: 'Classroom',
            element: <ClassDiary />,
            path: '/noticeboard/classroom',
            roleKey: 'classroom'
        },
        {
            name: 'Add Homework',
            element: <AddHomework />,
            path: '/noticeboard/classroom/homework/add',
            roleKey: 'classroom'
        },
        {
            name: 'Edit Homework',
            element: <AddHomework edit />,
            path: '/noticeboard/classroom/homework/edit/:id',
            roleKey: 'classroom'
        },
        {
            name: 'View Homework',
            element: <ViewHomework />,
            path: '/noticeboard/classroom/homework/view/:id',
            roleKey: 'classroom'
        },
        {
            name: 'Add Update',
            element: <AddUpdate />,
            path: '/noticeboard/classroom/updates/add',
            roleKey: 'classroom'
        },
        {
            name: 'Edit Update',
            element: <AddUpdate edit />,
            path: '/noticeboard/classroom/updates/edit/:id',
            roleKey: 'classroom'
        },
        {
            name: 'View Update',
            element: <ViewUpdate />,
            path: '/noticeboard/classroom/updates/view/:id',
            roleKey: 'classroom'
        },
        {
            name: 'Broadcasts',
            element: <Broadcasts />,
            path: '/noticeboard/broadcasts',
            roleKey: 'broadcasts'
        },
        {
            name: 'Add Broadcast',
            element: <AddBroadcast />,
            path: '/noticeboard/broadcasts/add',
            roleKey: 'broadcasts'
        },
        {
            name: 'Edit Broadcast',
            element: <AddBroadcast edit />,
            path: '/noticeboard/broadcasts/edit/:id',
            roleKey: 'broadcasts'
        },
        {
            name: 'View Broadcast',
            element: <ViewBroadcast />,
            path: '/noticeboard/broadcasts/view/:id',
            roleKey: 'broadcasts'
        },
    ],
    "branch-user":
    [
        {
            name  : 'Profile',
            element:<InstitutionProfile Type="Branch" />,
            path : '/',
            roleKey : 'profile'

        },
        {
            name  : 'Access Denied',
            element: <AccessDenied/>,
            path : '/access-denied',
            roleKey : 'accessDenied'
        },
        {
            name :  "Profile",
            element : <ViewStaff userType={"branch-user"} ApiType={"cognito"}/>,
            path : '/profile/my-profile',
            roleKey: "profile"
        },
        {
            name  : 'Profile',
            element: <UpdateProfilePassword Type="Institution"/>,
            path : '/profile/update-password',
            roleKey : 'profile'
        },
        {
            name  : 'Payment Gateway',
            element: <OnlinePayments />,
            path : '/settings/payment-gateway',
            roleKey : 'settings'
        },
        {
            name  : 'Branches',
            element:<ViewBranches />,
            path : '/manage-branches/:id',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<AddUser userType={"branch-user"} actionType={"Add"} />,
            path : '/manage-branches/:id/add-branch-user',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<AddUser userType={"branch-user"} actionType={"Add"} edit/>,
            path : '/manage-branches/:id/edit-branch-user/:email_address',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<ManageBranch />,
            path : '/manage-branches',
            roleKey: 'branches'
        },
    
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch />,
            path : '/manage-branches/onboard-new-branch',
            roleKey: 'branches'      
        },
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch edit/>,
            path : '/manage-branches/onboard-new-branch/edit/:id',
            roleKey: 'branches'      
        },
    
        {
            name  : 'Profile',
            element:<InstitutionProfile Type="Branch" />,
            path : '/profile/branch-profile',
            roleKey : 'profile'

        },
        // {
        //     name  : 'Profile',
        //     element:<EmptyScreen Type="Branch" />,
        //     path : '/profile/sign-in-status',
        //     roleKey : 'profile'

        // },
        {
            name :  "Holiday Management",
            element : <ManageHolidayCalendar type={'branchHoliday'}/>,
            path : '/holiday-management',
            roleKey: "holiday-management"
        },
        {
            name :  "Employee Directory",
            element : <ManageStaff />,
            path : '/employee-master/manage-employee',
            roleKey: "employee-directory"

        },
        {
            name :  "Employee Directory",
            element : <AddUser userType={"staff-user"} actionType={"Add"} />,
            path : '/employee-master/manage-employee/add-employee',
            roleKey: "employee-directory"
        },
        {
            name :  "Employee Directory",
            element : <AddUser userType={"staff-user"} actionType={"Edit"} edit />,
            path : '/employee-master/manage-employee/edit-staff/:email_address',
            roleKey: "employee-directory"
        },
        {
            name :  "Employee Directory",
            element : <ViewStaff userType={"staff-user"} ApiType={'API'}/>,
            path : '/employee-master/manage-employee/view-employee/:id',
            roleKey: "employee-directory"
        },
        
        {
            name :  "Main Hub",
            element : <ManageClasses type="sections"/>,
            path : '/main-hub/manage-sections',
            roleKey: "sections"
        },
        {
            name :  "Onboard Section",
            element : <AddClass userType={"staff-user"} actionType={"Add"} type={'sections'}/>,
            path : '/main-hub/manage-sections/add-section',
            roleKey: "sections"
        },
        {
            name : "Main Hub",
            element : <ReorderClasses type="sections" />,
            path : '/main-hub/manage-sections/reorder',
            roleKey: "sections"
        },
        

        {
            
            name :  "Classes",
            element : <ManageClasses type="classes"/>,
            path : '/main-hub/classes',
            roleKey: "classes"
        },
        {
            
            name :  "Classes",
            element : <AddClass Type={"Add"} type={'classes'}/>,
            path : '/main-hub/classes/add-class',
            roleKey: "classes"
        },
        {
            
            name :  "Classes",
            element : <AddClass Type={"Edit"}/>,
            path : '/main-hub/classes/edit-class/:id',
            roleKey: "classes"
        },
        {
            name : "Classes",
            element : <ReorderClasses />,
            path : '/main-hub/classes/reorder',
            roleKey: "classes"
        },
        {
            
            name :  "subjects",
            element : <ManageClasses type="subjects"/>,
            path : '/main-hub/subjects',
            roleKey: "subjects"
        },
        {
            name :  "subjects",
            element : <AddClass actionType={"Add"} type={'subjects'}/>,
            path : '/main-hub/subjects/add-subjects',
            roleKey: "subjects"
        },
        {
            name :  "subjects",
            element : <AddSubject actionType={"Edit"}/>,
            path : '/main-hub/subjects/edit-subjects/:id',
            roleKey: "subjects"
        },
        {
            
            name :  "Fee Heads",
            element : <ManageClasses type="fee head"/>,
            path : "/fee-management/fee-head",
            roleKey: "fee-heads"
        },
        {
            
            name :  "Fee Heads",
            element : <AddClass type="fee head"/>,
            path : "/fee-management/fee-head/add-fee-head",
            roleKey: "fee-heads"
        },
        {
            
            name  : 'Fee Structures',
            element : <AddFeeStructure Type={"Add"}/>,
            path : "/fee-management/fee-structure/add-fee-structure",
            roleKey: "fee-structures"
        },
        {
            
            name  : 'Fee Structures',
            element : <MangeFeeStructure />,
            path : "/fee-management/fee-structure",
            roleKey: "fee-structures"
        },
        {
            name:"Fee Structure",
            element:<AddFeeStructure Type={"Edit"}/>,
            path:"/fee-management/fee-structure/update-fee-structure/:fee_structure_id",
            roleKey:"fee-structures"
        },
        {
            name:"Fee Structure",
            element:<AddFeeStructure Type={"View"}/>,
            path:"/fee-management/fee-structure/view-fee-structure/:fee_structure_id",
            roleKey:"fee-structures"
        },
        { 
            name  : 'Ledgers/Groups',
            element : <ManageGroupsLedgers />,
            path : '/main-hub/groups-ledgers',
            roleKey:"ledgers/groups"
        },
        {
            
            name  : 'Ledgers/Groups',
            element : <AddEditGroupsLegers Type={"Add"}/>,
            path : '/main-hub/groups-ledgers/add-groups-ledgers',
            roleKey:"ledgers/groups"
        },
        {
            
            name  : 'Ledgers/Groups',
            element : <AddEditGroupsLegers Type={"Edit"}/>,
            path : '/main-hub/groups-ledgers/edit-groups-ledgers/:id',
            roleKey:"ledgers/groups"
        },
        {
            name: 'Ledger Details',
            element: <LedgerDetails/>,
            path: '/main-hub/groups-ledgers/ledger-details/:id', 
            roleKey: "groups-ledgers"
        },
        {
            
            name  : 'Exams',
            element : <ManageClasses type="exam"/>,
            path : "/student-master/exam",
            roleKey: 'exams'
        },
        {
            
            name  : 'Exams',
            element : <AddClass type="exam"/>,
            path : "/student-master/exam/add-exam",
            roleKey: 'exams'
        },
        {
            
            name :  "Directory",
            element : <ManageStudentsDirectoryList />,
            path : "/student-master/directory",
            roleKey: "directory"
        },
        {
            
            name :  "Directory",
            element : <AddStudent />,
            path : "/student-master/directory/add-student",
            roleKey: "directory"
        },
        {
            
            name :  "Directory",
            element : <AddStudent edit/>,
            path : "/student-master/directory/edit-student/:id",
            roleKey: "directory"
        },
        {
            name  : 'Directory',
            element:<ViewStudent />,
            path : '/student-master/directory/:id',
            roleKey: 'directory'
        },
        {
            name  : 'Directory',
            element:<UpdateFeeStructure />,
            path : '/student-master/directory/update-fee-structure',
            roleKey: 'directory'
        },
        {
            name  : 'Directory',
            element:<StudentList />,
            path : '/student-master/directory/update-fee-structure/student-list',
            roleKey: 'directory'
            
        },
        {
            name :  "Collect Fee",
            element : <CollectFee />,
            path : "/student-master/collect-fee",
            roleKey: "collect-fee"
        },
        {
            name :  "Collect Fee",
            element : <CollectFeeInvoice />,
            path : "/student-master/collect-fee/collect-fee-invoice/:id",
            roleKey: "collect-fee"
        },
        {
            name:"Term",
            element:<FeeTerm />,
            path:'/fee-management/fee-terms',
            roleKey:'fee-terms'
        },
        {
            name:"Term",
            element:<AddFeeTerm />,
            path:'/fee-management/fee-terms/create-fee-term',
            roleKey:'fee-terms'
        },
        {
            name:"Term",
            element:<AddFeeTerm edit/>,
            path:'/fee-management/fee-terms/view-fee-term/:id',
            roleKey:'fee-terms'
        },
        {
            
            name  : 'AcademicYear',
            element : <ManageAcademicYearList/>,
            path : '/manage-academic-years',
            roleKey : 'profile'
        },
        ,{
            
            name  : 'AcademicYear',
            element : <AddNewAcademicYear/>,
            path : '/manage-academic-years/add-new-academic-year',
            roleKey : 'profile'
        },
        {
            
            name  : 'AcademicYear',
            element : <AddNewAcademicYear edit/>,
            path : '/manage-academic-years/edit/:academic_year_id',
            roleKey : 'profile'
        },
        {
            
            name  : 'Class Association',
            element : <ManageAssociation/>,
            path : '/employee-master/manage-association',
            roleKey:"class-association"
        },
        {
            
            name  : 'Class Association',
            element : <AddAssociation/>,
            path : '/employee-master/manage-association/add-association',
            roleKey:"class-association"
        },
        {
                    
            
            name  : 'Class Association',
            element : <AddAssociation edit/>,
            path : '/employee-master/manage-association/add-association/:id',
            roleKey:"class-association"
        },
        {
            name  : 'Academic Reports',
            element : <AcademicRecords />,
            path : '/student-master/class-wise-academic-reports',
            roleKey:"academic-reports"
        },
        {
            name  : 'Student Attendance',
            element : <Attendance />,
            path : '/student-master/student-attendance',
            roleKey:"students-attendance"
        },
        {
            name  : 'View Attendance',
            element : <ViewIndividualAttendance />,
            path : '/student-master/student-attendance/view-attendance/:id/:name',
            roleKey:"students-attendance"
        },
        {
            name:'Student Attendance',
            element:<ModifyStudentAttendance/>,
            path:'/student-master/student-attendance/modify-attendance',
            roleKey:"students-attendance"
        },
        {
            name  : 'Financial Year',
            element:<FinancialYear/>,
            path:'/manage-financial-years',
            roleKey : 'profile'
        },
        // staff attendance

        {
            name  : 'Employee Attendance',
            element : <Attendance type={"staff"}/>,
            path : '/employee-master/employee-attendance',
            roleKey:"employees-attendance"
        },
        {
            name  : 'Staff View Attendance',
            element : <ViewIndividualAttendance type={"staff"}/>,
            path : '/employee-master/employee-attendance/view-attendance/:number/:name/:id',
            roleKey:"employees-attendance"
        },
        {
            name:'staff Attendance',
            element:<ModifyStudentAttendance type={"staff"}/>,
            path:'/employee-master/employee-attendance/modify-attendance',
            roleKey:"employees-attendance"
        },

        // Inventory List
        {
            name  : 'Inventory',
            element : <InventoryList />,
            path : '/inventory-master/inventory-list',
            roleKey:"inventory"
        },
        {
            name  : 'Inventory List Add',
            element : <AddInventoryList type={"Add"}/>,
            path : '/inventory-master/inventory-list/add-inventory',
            roleKey:"inventory"
        },
        {
            name:'Inventory List Edit',
            element:<AddInventoryList type={"Edit"}/>,
            path:'/inventory-master/inventory-list/edit-inventory/:id',
            roleKey:"inventory"
        },
        {
            name:'View GRN',
            element:<ViewGrn />,
            path:'/inventory-master/inventory-list/view-grn',
            roleKey:"inventory"
        },
        {
            name:'Issue-Inventory',
            element:<IssueInventory type={"inventory-master"}/>,
            path:'/inventory-master/inventory-list/issue-inventory',
            roleKey:"inventory"
        },

        // Purchase Order
        {
            name  : 'Purchase Order',
            element : <PurchaseOrder />,
            path : '/inventory-master/purchase-order',
            roleKey:"purchase-order"
        },
        {
            name  : 'Purchase Order Add',
            element : <AddPurchaseOrder type={"Add"}/>,
            path : '/inventory-master/purchase-order/add-purchase-order',
            roleKey:"purchase-order"
        },
        {
            name:'Purchase Order Edit',
            element:<AddPurchaseOrder type={"Edit"}/>,
            path:'/inventory-master/purchase-order/edit-purchase-order/:id',
            roleKey:"purchase-order"
        },
        {
            name:'Purchase Order View',
            element:<ViewPurchaseOrder />,
            path:'/inventory-master/purchase-order/view-purchase-order/:id',
            roleKey:"purchase-order"
        },

        // GRN Entry
        {
            name  : 'GRN Entry Add',
            element : <AddGRNEntry type={"Add"}/>,
            path : '/inventory-master/grn-entry/add-grn-entry',
            roleKey:"grn-entry"
        },
        {
            name  : 'GRN Entry List',
            element : <GRNList/>,
            path : '/inventory-master/grn-entry',
            roleKey:"grn-entry"
        },
        {
            name  : 'GRN Entry View',
            element : <ViewGRNDetails/>,
            path : '/inventory-master/grn-entry/view-grn-entry/:id',
            roleKey:"grn-entry"
        },

        // Payroll
        
        {
            name :  "Payroll",
            element : <Payroll />,
            path : '/employee-master/payroll',
            roleKey: "payroll"

        },
        // Invoices
        {
            name :  "Invoices",
            element : <InvoiceList />,
            path : '/student-master/invoice-list',
            roleKey: "invoices"
        },
        {
            name:'Invoice Details',
            element:<InvoiceDetails />,
            path:'/student-master/invoice-list/invoices-details/:id',
            roleKey:"invoices"
        },
        {
            name:'Issue-Inventory',
            element:<IssueInventory type={"student-master"}/>,
            path:'/student-master/invoice-list/issue-inventory',
            roleKey:"invoices"
        },
        //Promote Student
        {
            name :  "Promote Students",
            element : <PromoteStudent/>,
            path : '/student-master/promote-history/promote-students',
            roleKey: "promote-students"
        },
        {
            name :  "Promote History",
            element : <PromoteHistory/>,
            path : '/student-master/promote-history',
            roleKey: "promote-students"
        },
        {
            name :  "Promotion Details",
            element : <PromotionDetails/>,
            path : '/student-master/promote-history/promotion-details/:id',
            roleKey: "promote-students"
        },
        { 
            name: "Fee Collection Report",
            element: <FeeCollection />,
            path: '/student-master/fee-collection',
            roleKey: "fee-collection-report"
        },
        { 
            name: "Fee Collection Details",
            element: <FeeCollectionDetails />,
            path: '/student-master/fee-collection/fee-collection-details/:id',
            roleKey: "fee-collection-report"
        },
        { 
            name: "inventory-stock-report",
            element: <InventoryStockReport />,
            path: '/inventory-master/inventory-stock-report',
            roleKey: "inventory-stock-report"
        },
        { 
            name: "inventory-issue-report",
            element: <InventoryIssueReport/>, 
            path: '/inventory-master/inventory-issue-report',
            roleKey: "inventory-issue-report"
        },
        { 
            name: "payables",
            element: <Payables/>,
            path: '/accounting/payables',
            roleKey: "payables"
        },
        { 
            name: "balance-sheet",
            element: <BalanceSheet type={'main'}/>,
            path: '/financial-statements/balance-sheet',
            roleKey: "balance-sheet"
        },

        { 
            name: "profit-and-loss-sheet",
            element: <ProfitAndLoss type={'main'} />,
            path: '/financial-statements/profit-and-loss-sheet',
            roleKey: "profit-and-loss-sheet"
        },
        { 
            name: "trial-balance-sheet",
            element: <TrialBalance type={'main'} />,
            path: '/financial-statements/trial-balance-sheet',
            roleKey: "trial-balance-sheet"
        },
        { 
            name: "receipts-and-payments",
            element: <ReceiptsAndPayments type={'main'} />,
            path: '/financial-statements/receipts-and-payments',
            roleKey: "receipts-and-payments"
        },

        // Transfer Student
        {
            name :  "Transfers",
            element : <TransferStudent />,
            path : "/student-master/transfers",
            roleKey: "transfers"
        },
        {
            name :  "Transfers",
            element : <AddTransferStudent />,
            path : "/student-master/transfers/add-transfer-student",
            roleKey: "transfers"
        },
        // Process Transfer
        {
            name :  "Transfers",
            element : <ProcessTransfer />,
            path : "/student-master/transfers/process-transfer/:transfer_id",
            roleKey: "transfers"
        },
        // Voucher Entry
        {
            name: "vouchers-entry",
            element: <VouchersEntryList />,
            path: "/accounting/voucher-entry",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-contra",
            element: <VoucherContra />,
            path: "/accounting/voucher-entry/voucher-type-contra",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-receipt",
            element: <VoucherReceipt />,
            path: "/accounting/voucher-entry/voucher-type-receipt",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-RTES_cholarship",
            element: <VoucherRTEScholarship />,
            path: "/accounting/voucher-entry/voucher-type-RTE-Scholarship",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-journal",
            element: <VoucherJournal />,
            path: "/accounting/voucher-entry/voucher-type-journal",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-payment",
            element: <VoucherPayment />,
            path: "/accounting/voucher-entry/voucher-type-payment",
            roleKey: "vouchers-entry"
        },
        {
            name: "voucher-details",
            element: <VoucherDetails />,
            path: "/accounting/voucher-entry/voucher-details/:id",
            roleKey: "vouchers-entry"
        },
        {
            name: 'Bulk Invoice Issue History',
            element: <BulkInvoiceHistory />,
            path: '/student-master/invoice-list/bulk-invoice-history',
            roleKey: 'invoices'
        },
        {
            name: 'Invoice Issue Status',
            element: <InvoiceIssueStatus />,
            path: '/student-master/invoice-list/bulk-invoice-history/invoice-issue-status',
            roleKey: 'invoices'
        },
        {
            name: 'Classroom',
            element: <ClassDiary />,
            path: '/noticeboard/classroom',
            roleKey: 'classroom'
        },
        {
            name: 'Add Homework',
            element: <AddHomework />,
            path: '/noticeboard/classroom/homework/add',
            roleKey: 'classroom'
        },
        {
            name: 'Edit Homework',
            element: <AddHomework edit />,
            path: '/noticeboard/classroom/homework/edit/:id',
            roleKey: 'classroom'
        },
        {
            name: 'View Homework',
            element: <ViewHomework />,
            path: '/noticeboard/classroom/homework/view/:id',
            roleKey: 'classroom'
        },
        {
            name: 'Add Update',
            element: <AddUpdate />,
            path: '/noticeboard/classroom/updates/add',
            roleKey: 'classroom'
        },
        {
            name: 'Edit Update',
            element: <AddUpdate edit />,
            path: '/noticeboard/classroom/updates/edit/:id',
            roleKey: 'classroom'
        },
        {
            name: 'View Update',
            element: <ViewUpdate />,
            path: '/noticeboard/classroom/updates/view/:id',
            roleKey: 'classroom'
        },
        {
            name: 'Broadcasts',
            element: <Broadcasts />,
            path: '/noticeboard/broadcasts',
            roleKey: 'broadcasts'
        },
        {
            name: 'Add Broadcast',
            element: <AddBroadcast />,
            path: '/noticeboard/broadcasts/add',
            roleKey: 'broadcasts'
        },
        {
            name: 'Edit Broadcast',
            element: <AddBroadcast edit />,
            path: '/noticeboard/broadcasts/edit/:id',
            roleKey: 'broadcasts'
        },
        {
            name: 'View Broadcast',
            element: <ViewBroadcast />,
            path: '/noticeboard/broadcasts/view/:id',
            roleKey: 'broadcasts'
        },
    ],
    "staff-user":
    [
        {
            name  : 'Profile',
            element:<ViewStaff userType={"staff-user"} ApiType={"cognito"}/>,
            path : '/',
            roleKey : 'profile'

        },
        {
            name  : 'Access Denied',
            element: <AccessDenied/>,
            path : '/access-denied',
            roleKey : 'accessDenied'
        },
        {
            name :  "Profile",
            element : <ViewStaff userType={"staff-user"} ApiType={"cognito"}/>,
            path : '/profile/my-profile',
            roleKey: "profile"
        },
        // {
        //     name  : 'Profile',
        //     element:<EmptyScreen Type="Employee Directory" />,
        //     path : '/profile/sign-in-status',
        //     roleKey : 'profile'

        // },
        {
            name  : 'Profile',
            element: <UpdateProfilePassword Type="Institution"/>,
            path : '/profile/update-password',
            roleKey : 'profile'
        },
        {
            name  : 'Payment Gateway',
            element: <OnlinePayments />,
            path : '/settings/payment-gateway',
            roleKey : 'settings'
        },
        {
            name: 'Classroom',
            element: <ClassDiary />,
            path: '/noticeboard/classroom',
            roleKey: 'classroom'
        },
        {
            name: 'Add Homework',
            element: <AddHomework />,
            path: '/noticeboard/classroom/homework/add',
            roleKey: 'classroom'
        },
        {
            name: 'Edit Homework',
            element: <AddHomework edit />,
            path: '/noticeboard/classroom/homework/edit/:id',
            roleKey: 'classroom'
        },
        {
            name: 'View Homework',
            element: <ViewHomework />,
            path: '/noticeboard/classroom/homework/view/:id',
            roleKey: 'classroom'
        },
        {
            name: 'Add Update',
            element: <AddUpdate />,
            path: '/noticeboard/classroom/updates/add',
            roleKey: 'classroom'
        },
        {
            name: 'Edit Update',
            element: <AddUpdate edit />,
            path: '/noticeboard/classroom/updates/edit/:id',
            roleKey: 'classroom'
        },
        {
            name: 'View Update',
            element: <ViewUpdate />,
            path: '/noticeboard/classroom/updates/view/:id',
            roleKey: 'classroom'
        },
        {
            name  : 'Payslips',
            element: <Payslips />,
            path : '/profile/payslip',
            roleKey : 'profile'
        },
        {
            name :  "Holiday Management",
            element : <ManageHolidayCalendar type={'branchHoliday'}/>,
            path : '/holiday-management',
            roleKey: "holiday-management"
        },
        {
            name :  "Employee Directory",
            element : <ManageStaff />,
            path : '/employee-master/manage-employee',
            roleKey: "employee-directory"

        },
        {
            name :  "Employee Directory",
            element : <AddUser userType={"staff-user"} actionType={"Add"} />,
            path : '/employee-master/manage-employee/add-employee',
            roleKey: "employee-directory"
        },
        {
            name :  "Employee Directory",
            element : <AddUser userType={"staff-user"} actionType={"Edit"} edit />,
            path : '/employee-master/manage-employee/edit-staff/:email_address',
            roleKey: "employee-directory"
        },
        {
            name  : 'Branches',
            element:<AddUser userType={"branch-user"} actionType={"Add"} edit/>,
            path : '/manage-branches/:id/edit-branch-user/:email_address',
            roleKey: 'branches'
        },
        {
            name :  "Employee Directory",
            element : <ViewStaff userType={"staff-user"} ApiType={'API'}/>,
            path : '/employee-master/manage-employee/view-employee/:id',
            roleKey: "employee-directory"
        },
        {
            
            name :  "Classes",
            element : <ManageClasses type="classes"/>,
            path : '/main-hub/classes',
            roleKey: "classes"
        },
        {
            
            name :  "Classes",
            element : <AddClass Type={"Add"} type={'classes'}/>,
            path : '/main-hub/classes/add-class',
            roleKey: "classes"
        },
        {
            
            name :  "Classes",
            element : <AddClass Type={"Edit"} type={'classes'}/>,
            path : '/main-hub/classes/edit-class/:id',
            roleKey: "classes"
        },
        {
            name : "Classes",
            element : <ReorderClasses />,
            path : '/main-hub/classes/reorder',
            roleKey: "classes"
        },
        {
            name :  "Main Hub",
            element : <ManageClasses type="sections"/>,
            path : '/main-hub/manage-sections',
            roleKey: "sections"
        },
        {
            name :  "Onboard Section",
            element : <AddClass userType={"staff-user"} actionType={"Add"} type="sections"/>,
            path : '/main-hub/manage-sections/add-section',
            roleKey: "sections"
        },
        {
            name : "Main Hub",
            element : <ReorderClasses type="sections" />,
            path : '/main-hub/manage-sections/reorder',
            roleKey: "sections"
        },
        
        {
            
            name :  "subjects",
            element : <ManageClasses type="subjects"/>,
            path : '/main-hub/subjects',
            roleKey: "subjects"
        },
        {
            name :  "subjects",
            element : <AddClass actionType={"Add"} type={'subjects'}/>,
            path : '/main-hub/subjects/add-subjects',
            roleKey: "subjects"
        },
        {
            name :  "subjects",
            element : <AddSubject actionType={"Edit"}/>,
            path : '/main-hub/subjects/edit-subjects/:id',
            roleKey: "subjects"
        },
        {
            
            name :  "Fee Heads",
            element : <ManageClasses type="fee head"/>,
            path : "/fee-management/fee-head",
            roleKey: "fee-heads"
        },
        {
            
            name :  "Fee Heads",
            element : <AddClass type="fee head"/>,
            path : "/fee-management/fee-head/add-fee-head",
            roleKey: "fee-heads"
        },
        {
            
            name  : 'Fee Structures',
            element : <AddFeeStructure Type={"Add"}/>,
            path : "/fee-management/fee-structure/add-fee-structure",
            roleKey: "fee-structures"
        },
        {
            
            name  : 'Fee Structures',
            element : <MangeFeeStructure />,
            path : "/fee-management/fee-structure",
            roleKey: "fee-structures"
        },
        {
            name:"Fee Structure",
            element:<AddFeeStructure Type={"Edit"}/>,
            path:"/fee-management/fee-structure/update-fee-structure/:fee_structure_id",
            roleKey:"fee-structures"
        },
        {
            name:"Fee Structure",
            element:<AddFeeStructure Type={"View"}/>,
            path:"/fee-management/fee-structure/view-fee-structure/:fee_structure_id",
            roleKey:"fee-structures"
        },
        {
            name:"Term",
            element:<FeeTerm />,
            path:'/fee-management/fee-terms',
            roleKey:'fee-terms'
        },
        {
            name:"Term",
            element:<AddFeeTerm />,
            path:'/fee-management/fee-terms/create-fee-term',
            roleKey:'fee-terms'
        },
        {
            name:"Term",
            element:<AddFeeTerm edit/>,
            path:'/fee-management/fee-terms/view-fee-term/:id',
            roleKey:'fee-terms'
        },
        { 
            name  : 'Ledgers/Groups',
            element : <ManageGroupsLedgers />,
            path : '/main-hub/groups-ledgers',
            roleKey:"ledgers/groups"
        },
        {
            
            name  : 'Ledgers/Groups',
            element : <AddEditGroupsLegers Type={"Add"}/>,
            path : '/main-hub/groups-ledgers/add-groups-ledgers',
            roleKey:"ledgers/groups"
        },
        {
            
            name  : 'Ledgers/Groups',
            element : <AddEditGroupsLegers Type={"Edit"}/>,
            path : '/main-hub/groups-ledgers/edit-groups-ledgers/:id',
            roleKey:"ledgers/groups"
        },
        {
            name: 'Ledger Details',
            element: <LedgerDetails/>,
            path: '/main-hub/groups-ledgers/ledger-details/:id',
            roleKey: "groups-ledgers"
        },
        {
            
            name  : 'InstitutionUsers',
            element : <ManageInstitutionUserList/>,
            path : '/manage-institution-users',
            roleKey:"institution-users"
        },
        {
            
            name  : 'Exams',
            element : <ManageClasses type="exam"/>,
            path : "/student-master/exam",
            roleKey: 'exams'
        },
        {
            
            name  : 'Exams',
            element : <AddClass type="exam"/>,
            path : "/student-master/exam/add-exam",
            roleKey: 'exams'
        },
        {
            
            name :  "Directory",
            element : <ManageStudentsDirectoryList />,
            path : "/student-master/directory",
            roleKey: "directory"
        },
        {
            
            name :  "Directory",
            element : <AddStudent />,
            path : "/student-master/directory/add-student",
            roleKey: "directory"
        },
        {
            
            name :  "Directory",
            element : <AddStudent edit/>,
            path : "/student-master/directory/edit-student/:id",
            roleKey: "directory"
        },
        {
            name  : 'Directory',
            element:<ViewStudent />,
            path : '/student-master/directory/:id',
            roleKey: 'directory'
        },
        {
            name  : 'Directory',
            element:<UpdateFeeStructure />,
            path : '/student-master/directory/update-fee-structure',
            roleKey: 'directory'
        },
        {
            name  : 'Directory',
            element:<StudentList />,
            path : '/student-master/directory/update-fee-structure/student-list',
            roleKey: 'directory'
            
        },
        {
            
            name :  "Collect Fee",
            element : <CollectFee />,
            path : "/student-master/collect-fee",
            roleKey: "collect-fee"
        },
        {
            name :  "Collect Fee",
            element : <CollectFeeInvoice />,
            path : "/student-master/collect-fee/collect-fee-invoice/:id",
            roleKey: "collect-fee"
        },
        {
            
            name  : 'AcademicYear',
            element : <ManageAcademicYearList/>,
            path : '/manage-academic-years',
            roleKey : 'profile'
        },
        ,{
            
            name  : 'AcademicYear',
            element : <AddNewAcademicYear/>,
            path : '/manage-academic-years/add-new-academic-year',
            roleKey : 'profile'
        },
        {
            
            name  : 'AcademicYear',
            element : <AddNewAcademicYear edit/>,
            path : '/manage-academic-years/edit/:academic_year_id',
            roleKey : 'profile'
        },
        {
            
            name  : 'Class Association',
            element : <ManageAssociation />,
            path : '/employee-master/manage-association',
            roleKey:"class-association"
        },
        {
            
            name  : 'Class Association',
            element : <AddAssociation/>,
            path : '/employee-master/manage-association/add-association',
            roleKey:"class-association"
        },
        {
            
            name  : 'Class Association',
            element : <AddAssociation edit/>,
            path : '/employee-master/manage-association/add-association/:id',
            roleKey:"class-association"
        },
        {
            name  : 'Academic Reports',
            element : <AcademicRecords />,
            path : '/student-master/class-wise-academic-reports',
            roleKey:"academic-reports"
        },
        {
            name  : 'Student Attendance',
            element : <Attendance />,
            path : '/student-master/student-attendance',
            roleKey:"students-attendance"
        },
        {
            name  : 'View Attendance',
            element : <ViewIndividualAttendance />,
            path : '/student-master/student-attendance/view-attendance/:id/:name',
            roleKey:"students-attendance"
        },
        {
            name:'Student Attendance',
            element:<ModifyStudentAttendance/>,
            path:'/student-master/student-attendance/modify-attendance',
            roleKey:"students-attendance"
        },
        {
            name  : 'Financial Year',
            element:<FinancialYear/>,
            path:'/manage-financial-years',
            roleKey : 'profile'
        },
        // staff attendance

        {
            name  : 'Employee Attendance',
            element : <Attendance type={"staff"}/>,
            path : '/employee-master/employee-attendance',
            roleKey:"employees-attendance"
        },
        {
            name  : 'Staff View Attendance',
            element : <ViewIndividualAttendance type={"staff"}/>,
            path : '/employee-master/employee-attendance/view-attendance/:number/:name/:id',
            roleKey:"employees-attendance"
        },
        {
            name:'staff Attendance',
            element:<ModifyStudentAttendance type={"staff"}/>,
            path:'/employee-master/employee-attendance/modify-attendance',
            roleKey:"employees-attendance"
        },

        // Inventory List
        {
            name  : 'Inventory',
            element : <InventoryList />,
            path : '/inventory-master/inventory-list',
            roleKey:"inventory"
        },
        {
            name  : 'Inventory List Add',
            element : <AddInventoryList type={"Add"}/>,
            path : '/inventory-master/inventory-list/add-inventory',
            roleKey:"inventory"
        },
        {
            name:'Inventory List Edit',
            element:<AddInventoryList type={"Edit"}/>,
            path:'/inventory-master/inventory-list/edit-inventory/:id',
            roleKey:"inventory"
        },
        {
            name:'View GRN',
            element:<ViewGrn />,
            path:'/inventory-master/inventory-list/view-grn',
            roleKey:"inventory"
        },
        {
            name:'Issue-Inventory',
            element:<IssueInventory type={"inventory-master"}/>,
            path:'/inventory-master/inventory-list/issue-inventory',
            roleKey:"inventory"
        },

        // Purchase Order
        {
            name  : 'Purchase Order',
            element : <PurchaseOrder />,
            path : '/inventory-master/purchase-order',
            roleKey:"purchase-order"
        },
        {
            name  : 'Purchase Order Add',
            element : <AddPurchaseOrder type={"Add"}/>,
            path : '/inventory-master/purchase-order/add-purchase-order',
            roleKey:"purchase-order"
        },
        {
            name:'Purchase Order Edit',
            element:<AddPurchaseOrder type={"Edit"}/>,
            path:'/inventory-master/purchase-order/edit-purchase-order/:id',
            roleKey:"purchase-order"
        },
        {
            name:'Purchase Order View',
            element:<ViewPurchaseOrder />,
            path:'/inventory-master/purchase-order/view-purchase-order/:id',
            roleKey:"purchase-order"
        },

        // GRN Entry
        {
            name  : 'GRN Entry Add',
            element : <AddGRNEntry type={"Add"}/>,
            path : '/inventory-master/grn-entry/add-grn-entry',
            roleKey:"grn-entry"
        },
        {
            name  : 'GRN Entry List',
            element : <GRNList/>,
            path : '/inventory-master/grn-entry',
            roleKey:"grn-entry"
        },
        {
            name  : 'GRN Entry View',
            element : <ViewGRNDetails/>,
            path : '/inventory-master/grn-entry/view-grn-entry/:id',
            roleKey:"grn-entry"
        },
        // Payroll
        
        {
            name :  "Payroll",
            element : <Payroll />,
            path : '/employee-master/payroll',
            roleKey: "payroll"

        },
        // Invoices
        {
            name :  "Invoices",
            element : <InvoiceList />,
            path : '/student-master/invoice-list',
            roleKey: "invoices"
        },
        {
            name:'Invoice Details',
            element:<InvoiceDetails />,
            path:'/student-master/invoice-list/invoices-details/:id',
            roleKey:"invoices"
        },
        {
            name:'Issue-Inventory',
            element:<IssueInventory type={"student-master"}/>,
            path:'/student-master/invoice-list/issue-inventory',
            roleKey:"invoices"
        },

        //Promote Student
        {
            name :  "Promote Students",
            element : <PromoteStudent/>,
            path : '/student-master/promote-history/promote-students',
            roleKey: "promote-students"
        },
        {
            name :  "Promote History",
            element : <PromoteHistory/>,
            path : '/student-master/promote-history',
            roleKey: "promote-students"
        },
        {
            name :  "Promotion Details",
            element : <PromotionDetails/>,
            path : '/student-master/promote-history/promotion-details/:id',
            roleKey: "promote-students"
        },
        { 
            name: "Fee Collection Report",
            element: <FeeCollection />,
            path: '/student-master/fee-collection',
            roleKey: "fee-collection-report"
        },
        { 
            name: "Fee Collection Details",
            element: <FeeCollectionDetails />,
            path: '/student-master/fee-collection/fee-collection-details/:id',
            roleKey: "fee-collection-report"
        },
        { 
            name: "inventory-stock-report",
            element: <InventoryStockReport />,
            path: '/inventory-master/inventory-stock-report',
            roleKey: "inventory-stock-report"
        },
        { 
            name: "inventory-issue-report",
            element: <InventoryIssueReport/>, 
            path: '/inventory-master/inventory-issue-report',
            roleKey: "inventory-issue-report"
        },

        { 
            name: "payables",
            element: <Payables/>,
            path: '/accounting/payables',
            roleKey: "payables"
        },
        { 
            name: "balance-sheet",
            element: <BalanceSheet type={'main'}/>,
            path: '/financial-statements/balance-sheet',
            roleKey: "balance-sheet"
        },

        { 
            name: "profit-and-loss-sheet",
            element: <ProfitAndLoss type={'main'} />,
            path: '/financial-statements/profit-and-loss-sheet',
            roleKey: "profit-and-loss-sheet"
        },
        { 
            name: "trial-balance-sheet",
            element: <TrialBalance type={'main'} />,
            path: '/financial-statements/trial-balance-sheet',
            roleKey: "trial-balance-sheet"
        },
        { 
            name: "receipts-and-payments",
            element: <ReceiptsAndPayments type={'main'} />,
            path: '/financial-statements/receipts-and-payments',
            roleKey: "receipts-and-payments"
        },
        
        // Transfer Student
        {
            name :  "Transfers",
            element : <TransferStudent />,
            path : "/student-master/transfers",
            roleKey: "transfers"
        },
        {
            name :  "Transfers",
            element : <AddTransferStudent />,
            path : "/student-master/transfers/add-transfer-student",
            roleKey: "transfers"
        },
        // Process Transfer
        {
            name :  "Transfers",
            element : <ProcessTransfer />,
            path : "/student-master/transfers/process-transfer/:transfer_id",
            roleKey: "transfers"
        },
        // Voucher Entry
        {
            name: "vouchers-entry",
            element: <VouchersEntryList />,
            path: "/accounting/voucher-entry",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-contra",
            element: <VoucherContra />,
            path: "/accounting/voucher-entry/voucher-type-contra",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-receipt",
            element: <VoucherReceipt />,
            path: "/accounting/voucher-entry/voucher-type-receipt",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-RTES_cholarship",
            element: <VoucherRTEScholarship />,
            path: "/accounting/voucher-entry/voucher-type-RTE-Scholarship",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-journal",
            element: <VoucherJournal />,
            path: "/accounting/voucher-entry/voucher-type-journal",
            roleKey: "vouchers-entry"
        },
        {
            name: "vouchers-type-payment",
            element: <VoucherPayment />,
            path: "/accounting/voucher-entry/voucher-type-payment",
            roleKey: "vouchers-entry"
        },
        {
            name: "voucher-details",
            element: <VoucherDetails />,
            path: "/accounting/voucher-entry/voucher-details/:id",
            roleKey: "vouchers-entry"
        },
        {
            name: 'Bulk Invoice Issue History',
            element: <BulkInvoiceHistory />,
            path: '/student-master/invoice-list/bulk-invoice-history',
            roleKey: 'invoices'
        },
        {
            name: 'Invoice Issue Status',
            element: <InvoiceIssueStatus />,
            path: '/student-master/invoice-list/bulk-invoice-history/invoice-issue-status',
            roleKey: 'invoices'
        },
        {
            name: 'Broadcasts',
            element: <Broadcasts />,
            path: '/noticeboard/broadcasts',
            roleKey: 'broadcasts'
        },
        {
            name: 'Add Broadcast',
            element: <AddBroadcast />,
            path: '/noticeboard/broadcasts/add',
            roleKey: 'broadcasts'
        },
        {
            name: 'Edit Broadcast',
            element: <AddBroadcast edit />,
            path: '/noticeboard/broadcasts/edit/:id',
            roleKey: 'broadcasts'
        },
        {
            name: 'View Broadcast',
            element: <ViewBroadcast />,
            path: '/noticeboard/broadcasts/view/:id',
            roleKey: 'broadcasts'
        },
    ],
    'no-branch':[
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch />,
            path : '/',
            roleKey : 'branches'

        },
        {
            name  : 'Access Denied',
            element: <AccessDenied/>,
            path : '/access-denied',
            roleKey : 'accessDenied'
        },
        {
            name :  "Profile",
            element : <ViewStaff userType={"institution-admin"} ApiType={"cognito"}/>,
            path : '/profile/my-profile',
            roleKey: "profile"
        },
        {
            name  : 'Profile',
            element: <UpdateProfilePassword Type="Institution"/>,
            path : '/profile/update-password',
            roleKey : 'profile'
        },
        {
            name  : 'Payment Gateway',
            element: <OnlinePayments />,
            path : '/settings/payment-gateway',
            roleKey : 'settings'
        },
        {
            name  : 'Branches',
            element:<ViewBranches />,
            path : '/manage-branches/:id',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<AddUser userType={"institution-user"} actionType={"Add"}/>,
            path : '/manage-branches/:id/add-branch-user',
            roleKey: 'branches'
        },
        {
            name  : 'Branches',
            element:<ManageBranch />,
            path : '/manage-branches',
            roleKey: 'branches'
        },
        
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch />,
            path : '/manage-branches/onboard-new-branch',
            roleKey: 'branches'      
        },
        {
            name  : 'Onboard New Branch',
            element:<OnboardNewBranch edit/>,
            path : '/manage-branches/onboard-new-branch/edit/:id',
            roleKey: 'branches'      
        },
        {
            name  : 'Profile',
            element:<InstitutionProfile Type="Branch" />,
            path : '/profile/branch-profile',
            roleKey : 'profile'

        },
        // {
        //     name  : 'Profile',
        //     element:<EmptyScreen Type="Branch" />,
        //     path : '/profile/sign-in-status',
        //     roleKey : 'profile'

        // },
        {
            name :  "Profile",
            element : <ViewStaff userType={"staff-user"} ApiType={"cognito"}/>,
            path : '/profile/my-profile',
            roleKey: "profile"
        },
        {
            name  : 'Profile',
            element:<InstitutionProfile Type="Branch" />,
            path : '/profile/branch-profile',
            roleKey : 'profile'

        },
        {
            name  : 'Profile',
            element:<InstitutionProfile Type="Institution" />,
            path : '/profile/institution-profile',
            roleKey : 'profile'

        },
        // {
        //     name  : 'Profile',
        //     element:<EmptyScreen Type="Employee Directory" />,
        //     path : '/profile/sign-in-status',
        //     roleKey : 'profile'

        // },
        {
            name  : 'Profile',
            element: <UpdateProfilePassword Type="Institution"/>,
            path : '/profile/update-password',
            roleKey : 'profile'
        },
        {
            name  : 'Payment Gateway',
            element: <OnlinePayments />,
            path : '/settings/payment-gateway',
            roleKey : 'settings'
        },
    ]
}
